import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_emp_missing_report_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  emp_pkid: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  entity_name: fromDatatype.TextDatatypeInterface;
  entity_pkid: fromDatatype.TextDatatypeInterface;
  company_name: fromDatatype.TextDatatypeInterface;
  company_pkid: fromDatatype.TextDatatypeInterface;
  location_name: fromDatatype.TextDatatypeInterface;
  location_pkid: fromDatatype.TextDatatypeInterface;
  branch_name: fromDatatype.TextDatatypeInterface;
  branch_pkid: fromDatatype.TextDatatypeInterface;
  syncing_status: fromDatatype.TextDatatypeInterface;
}

export class bl_fi_emp_missing_report_hdr_RowClass implements bl_fi_emp_missing_report_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  emp_pkid: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  entity_name: fromDatatype.TextDatatypeInterface;
  entity_pkid: fromDatatype.TextDatatypeInterface;
  company_name: fromDatatype.TextDatatypeInterface;
  company_pkid: fromDatatype.TextDatatypeInterface;
  location_name: fromDatatype.TextDatatypeInterface;
  location_pkid: fromDatatype.TextDatatypeInterface;
  branch_name: fromDatatype.TextDatatypeInterface;
  branch_pkid: fromDatatype.TextDatatypeInterface;
  syncing_status: fromDatatype.TextDatatypeInterface;
}